import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const externalImportRoute: InvariantJiraRoute = {
	name: 'external-import',
	path: '/jira/settings/system/external-import',
};
